/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiMediaFileFromJSON, ApiMediaFileToJSON, } from './ApiMediaFile';
import { ApiMediaTypeFromJSON, ApiMediaTypeToJSON, } from './ApiMediaType';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiMediaFromJSON(json) {
    return ApiMediaFromJSONTyped(json, false);
}
export function ApiMediaFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'files': !exists(json, 'files') ? undefined : (json['files'].map(ApiMediaFileFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'type': !exists(json, 'type') ? undefined : ApiMediaTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}
export function ApiMediaToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'files': value.files === undefined ? undefined : (value.files.map(ApiMediaFileToJSON)),
        'id': value.id,
        'name': value.name,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'type': ApiMediaTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'version': value.version,
    };
}
